<div class="successful-snackbar-wrapper">
  <div class="content-wrapper">
    <i class="success-icon"></i>
    <div class="text-wrapper">
      <span class="main-text">Success</span>
      <span class="supporting-text" *ngIf="data.success_code"></span>
    </div>
  </div>

  <mat-icon (click)="closeSnackBar()">close</mat-icon>
</div>
